import { UITheme } from './UITheme';
import * as Phaser from 'phaser';

export class BossHealthBar extends Phaser.GameObjects.Container {
    private bar: Phaser.GameObjects.Graphics;
    private background: Phaser.GameObjects.Graphics;
    private text: Phaser.GameObjects.Text;
    private currentHealth: number = 0;
    private maxHealth: number = 100;
    private targetHealth: number = 0;

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);

        const width = scene.scale.width;
        const barWidth = width * 0.6;
        const barHeight = 44;

        // Center top
        this.setPosition(width / 2 - barWidth / 2, 118);

        // Background
        this.background = scene.add.graphics();
        this.background.fillStyle(UITheme.background, 0.8);
        this.background.fillRoundedRect(0, 0, barWidth, barHeight, 5);
        this.background.lineStyle(2, 0xffffff, 1);
        this.background.strokeRoundedRect(0, 0, barWidth, barHeight, 5);
        this.add(this.background);

        // Bar
        this.bar = scene.add.graphics();
        this.add(this.bar);

        // Text
        this.text = scene.add.text(barWidth / 2, barHeight / 2, '', {
            fontFamily: UITheme.body,
            fontSize: '16px',
            color: '#ffffff',
            fontStyle: 'bold'
        }).setOrigin(0.5);
        this.add(this.text);

        this.setVisible(false);
        this.setScrollFactor(0);
        this.setDepth(101); // Above HUD
    }

    public show(name: string, maxHealth: number): void {
        this.setVisible(true);
        this.maxHealth = maxHealth;
        this.currentHealth = maxHealth;
        this.targetHealth = maxHealth;
        this.text.setText(name);
        this.redrawFrame();
        this.updateBar();

        // Animate appearance
        this.setAlpha(0);
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            duration: 500
        });
    }

    public updateHealth(current: number): void {
        this.targetHealth = Math.max(0, current);
        // We can animate bar in update loop or just tween a value if we want smooth
        // For now, usage of update method is better for smooth transition
    }

    public hide(): void {
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            duration: 500,
            onComplete: () => {
                this.setVisible(false);
            }
        });
    }

    public resize(): void {
        this.redrawFrame();
        this.updateBar();
    }

    public override update(_time: number, _delta: number): void {
        if (!this.visible) return;

        // Smooth lerp
        this.currentHealth = Phaser.Math.Linear(this.currentHealth, this.targetHealth, 0.1);
        this.updateBar();
    }

    private updateBar(): void {
        const width = this.scene.scale.width * 0.6;
        const height = 44;
        const percent = Phaser.Math.Clamp(this.currentHealth / this.maxHealth, 0, 1);

        this.bar.clear();
        this.bar.fillStyle(0xe47c69, 1);
        this.bar.fillRoundedRect(2, 2, (width - 4) * percent, height - 4, 3);
    }

    private redrawFrame(): void {
        const width = this.scene.scale.width;
        const barWidth = width * 0.6;
        const barHeight = 44;

        this.setPosition(width / 2 - barWidth / 2, 118);
        this.background.clear();
        this.background.fillStyle(UITheme.background, 0.8);
        this.background.fillRoundedRect(0, 0, barWidth, barHeight, 5);
        this.background.lineStyle(2, 0xffffff, 1);
        this.background.strokeRoundedRect(0, 0, barWidth, barHeight, 5);
        this.text.setWordWrapWidth(barWidth - 20);
        this.text.setPosition(barWidth / 2, barHeight / 2);
    }
}
